// extracted by mini-css-extract-plugin
module.exports = {"speaker":"speaker_speaker__Pfq06","social":"speaker_social__GmY2d","details":"speaker_details__bQkhc"};